import React from "react";
import { useTranslation } from "react-i18next";
import { Formik, Form } from "formik";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";

import AuthLayout from "../../layouts/AuthLayout";
import FormField from "../../components/FormField";
import { REGISTER, USERS_TYPE } from "../../data/Constants";
import RippleButton from "../../components/buttons/RippleButton";
import { login } from "../../redux/slices/authSlice";

const SignIn = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loading = useSelector((state) => state.auth.loading);
    const isUserVerified = useSelector((state) => state.auth.isUserVerified);

    const validationSchema = Yup.object({
        email: Yup.string()
            .email("Invalid email address")
            .required("Email is required")
            .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Invalid email address"),
        password: Yup.string().required("Password is required"),
    });

    const initialValues = {
        email: "",
        password: "",
    };

    return (
        <AuthLayout rightContainerClassName="mt-226-sigin">
            <section>
                <h5 className="fs-22 fw-600 text-gray-900">{t("COMMON.SIGN.IN")}</h5>
                {/* {isUserVerified ? (
          <div className="fs-16 text-gray-300 fw-500">
            {t("COMMON.LOGIN.WITH.ID.AND.PASSWORD")}
          </div>
        ) : ( */}

                {/* )} */}
            </section>
            <section>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                        const user = { ...values };
                        user["user_type"] = USERS_TYPE.USER;
                        dispatch(login({ user, navigate, dispatch }));
                    }}
                >
                    {() => (
                        <Form className="row">
                            <FormField label="User ID - Email Address" name="email" type="email" fieldSize="col-12" labelFontColor="text-gray-950" footerPlaceholder="Please enter your email" />
                            <FormField
                                label="Password"
                                name="password"
                                type="password"
                                fieldSize="col-12"
                                isForgotPasswordField={true}
                                labelFontColor="text-gray-950"
                                footerPlaceholder="Please enter your password"
                            />

                            <div className="d-flex justify-content-between align-items-center auth-login-button">
                                <div className="fs-16 text-gray-300 fw-500">
                                    {t("COMMON.DONT.HAVE.ACCOUNT")}&nbsp;
                                    <Link className="text-primary-sapphire cursor-pointer text-decoration-none fw-600" to={REGISTER}>
                                        {t("COMMON.CLICK.TO.REGISTER")}
                                    </Link>
                                </div>
                                <RippleButton type="submit" isLoading={loading}>
                                    {t("COMMON.LOGIN")}
                                </RippleButton>
                            </div>
                        </Form>
                    )}
                </Formik>
            </section>
        </AuthLayout>
    );
};

export default SignIn;
